import React from "react";
import useFormInstance from "antd/es/form/hooks/useFormInstance";
import { Input, DatePicker } from "antd";

const InputField = ({
  placeholder,
  name,
  type,
  inputType,
  maxLength,
  disabled,
  prefix,
}) => {
  const form = useFormInstance();
  const allowedSpecialCharsForEmail = "@.";

  const handleInput = (e) => {
    const { value } = e.target;

    if (inputType === "onlyCharacters" && !/^[a-zA-Z\s]*$/.test(value)) {
      return;
    }

    if (inputType === "onlyNumbers" && !/^[0-9]*$/.test(value)) {
      return;
    }

    if (inputType === "both") {
      const regex = new RegExp(`^[a-zA-Z0-9@#$!^&*()]*$`);
      if (!regex.test(value)) {
        return;
      }
    }

    if (inputType === "email") {
      const emailRegex = new RegExp(
        `^[a-zA-Z0-9${allowedSpecialCharsForEmail.replace(
          /[.*+?^${}()|[\]\\]/g,
          "\\$&"
        )}]*$`
      );
      if (!emailRegex.test(value)) {
        return;
      }
    }

    form.setFieldValue(name, value);
  };

  const updateFormValue = (name, value) => {
    form.setFieldValue(name, value);
  };

  return type === "password" ? (
    <Input.Password
      placeholder={placeholder}
      className="h-11 rounded-lg"
      value={form.getFieldValue(name)}
      onChange={handleInput}
      disabled={disabled}
    />
  ) : type === "date" ? (
    <DatePicker
      value={form.getFieldValue(name)}
      className="h-11 rounded-lg w-full"
      placeholder={placeholder}
      onChange={(val) => {
        updateFormValue(name, val);
      }}
      format="MM/DD/YYYY"
      disabled={disabled}
    />
  ) : (
    <Input
      placeholder={placeholder}
      className="h-11 rounded-lg w-full"
      value={form.getFieldValue(name)}
      maxLength={maxLength}
      onChange={handleInput}
      disabled={disabled}
      prefix={prefix}
    />
  );
};
export default InputField;
